<template>
  <div class='apps'>
    <Sidebar @SetData='setData'></Sidebar>
    <div class="wicket">
      <Navs :navData='navData'></Navs>
      <div class="main">
          <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import Navs from './components/nav'
import Sidebar from './components/sidebar'
export default {
  name: 'apps',

  components: { Navs, Sidebar },

  data () {
    return {
      navData: {}
    }
  },

  methods: {
    setData (val) {
      this.navData = val
    }
  }
}
</script>

<style lang='stylus' scoped>
  .apps
    width 100%
    height 100%
    display flex
    background #f3f7fd
    .wicket
      flex auto
      overflow hidden
      margin 0 40px 20px
      display flex
      flex-direction column
      .main
        flex auto
        overflow hidden
        margin-top 20px
        border-radius 10px
        background #ffffff
        padding 20px
</style>
